import { render, staticRenderFns } from "./VideoIntroduction.vue?vue&type=template&id=0cae79b5"
import script from "./VideoIntroduction.vue?vue&type=script&lang=js"
export * from "./VideoIntroduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/b08365e4-b55a-4269-82b4-b5e5a1490008/workspace/hsylc_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cae79b5')) {
      api.createRecord('0cae79b5', component.options)
    } else {
      api.reload('0cae79b5', component.options)
    }
    module.hot.accept("./VideoIntroduction.vue?vue&type=template&id=0cae79b5", function () {
      api.rerender('0cae79b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sl/Application/Form/VideoIntroduction.vue"
export default component.exports